import { z } from 'zod'

/**
 * 產品主類目 - 新增/更新 Response Schema
 */
export const upsertProductMainResponseSchema = z.object({
  /** 主類目ID */
  pmID: z.number(),
  /** 主類目名稱(中) */
  nameZh: z.string()
})

/**
 * 產品主類目 - 新增/更新 Response
 */
export interface UpsertProductMainResponse
  extends z.infer<typeof upsertProductMainResponseSchema> {}
